export default "__VITE_ASSET__13708742__"